<template>
  <div class="card text-left mb-2">
    <div class="card-header">
      <div class="row">
        <div class="col-auto pr-0">
          <span
            v-if="
              $store.getters.user.Starred_Students.some(
                s => s.Student_Id == student.Student_Id
              )
            "
            class="material-icons pointer"
            v-on:click="removeStarStudent"
            v-bind:id="'starredStudent' + student.Student_Id"
            @mouseover="$showTooltip('#starredStudent' + student.Student_Id)"
            @mouseleave="$hideTooltip('#starredStudent' + student.Student_Id)"
            data-placement="top"
            title="Remove student from starred students (appears on dashboard)."
          >
            star
          </span>
          <span
            v-else
            class="material-icons pointer"
            v-on:click="createStarStudent"
            v-bind:id="'starStudent' + student.Student_Id"
            @mouseover="$showTooltip('#starStudent' + student.Student_Id)"
            @mouseleave="$hideTooltip('#starStudent' + student.Student_Id)"
            data-placement="top"
            title="Add student to starred students (appears on dashboard)."
          >
            star_border
          </span>
        </div>
        <div class="col-auto">
          <h5
            v-if="
              $canManageStudent(
                this.$store.getters.user.Permissions,
                student.Student_Id
              )
            "
            class="pointer d-inline-block btn-link mb-0"
            v-on:click="$emit('student-selected', student)"
          >
            <strong>{{ student.Name }}</strong>
          </h5>
          <h5 v-else class="d-inline-block mb-0">
            <strong>{{ student.Name }}</strong>
          </h5>
        </div>
        <div class="col-auto">
          <h6 class="text-secondary pt-1 d-inline ml-4">
            <strong>Grade:</strong> {{ student.Grade.Title }}
          </h6>
        </div>
        <div class="col" />
      </div>
    </div>
    <div class="card-body">
      <div v-if="!$route.path.includes('dashboard')" class="row">
        <div class="col-auto pr-0">
          <p><strong>Group(s):</strong></p>
        </div>
        <div
          class="col-auto"
          v-for="organization in student.Organizations"
          :key="organization.Organization_Id"
        >
          <p>{{ organization.Name }}</p>
        </div>
        <div class="col" />
      </div>
      <div
        class="row"
        v-for="subject in student.Subjects.slice().sort($orderByTitle)"
        :key="subject.Subject_Id"
      >
        <div class="col-auto">
          <p class="my-0">
            <strong>{{ subject.Title }}</strong>
          </p>
        </div>
        <div
          class="col-auto"
          v-for="studentUnit in student.Student_Units.filter(
            u => u.Unit.Subject_Id == subject.Subject_Id
          )
            .slice()
            .sort($orderByUnitTitle)"
          :key="studentUnit.Unit_Id"
        >
          <p
            class="pointer btn-link mb-0"
            v-on:click="$emit('student-unit-selected', student, studentUnit)"
          >
            {{ studentUnit.Unit.Title }} Data
          </p>
        </div>
      </div>
      <p v-if="student.Subjects.length == 0" class="mb-0">
        This student is not assigned to any subjects.
      </p>
      <div
        v-if="
          !HideBehavior &&
            BehaviorTrackers != null &&
            BehaviorTrackers.some(
              t =>
                t.Is_Archived == false &&
                t.Student.Student_Id == Student.Student_Id
            )
        "
        class="row"
      >
        <div class="col-auto pr-0">
          <p><strong>Behavior Trackers:</strong></p>
        </div>
        <div
          class="col-auto pointer"
          v-for="tracker in BehaviorTrackers.filter(
            t =>
              t.Is_Archived == false &&
              t.Student.Student_Id == Student.Student_Id
          )"
          :key="tracker.Behavior_Tracker_Id + 'tracker'"
        >
          <p
            v-on:click="$emit('student-tracker-selected', student, tracker)"
            class="btn-link mb-0"
          >
            {{ tracker.Title }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Student: Object,
    CanEdit: Boolean,
    BehaviorTrackers: Array,
    HideBehavior: Boolean
  },
  data() {
    return {
      student: this.Student
    };
  },
  methods: {
    async removeStarStudent() {
      this.$store.commit("updateLoading", true);
      await this.$removeStarStudent(this.student.Student_Id);
      this.$emit("starred-student-removed", this.student.Student_Id);
      this.$store.commit("updateLoading", false);
    },
    async createStarStudent() {
      this.$store.commit("updateLoading", true);
      await this.$createStarStudent(this.student.Student_Id);
      this.$store.commit("updateLoading", false);
    }
  }
};
</script>
